export const API_URL_AUTH: string = "https://back.galera.fm/api/auth";
export const API_URL_USER: string = "https://back.galera.fm/api/user";
export const API_URL_PROJECT: string = "https://back.galera.fm/api/Projects";
export const API_URL_COMPANY: string = "https://back.galera.fm/api/Company";
export const API_URL_CONTACT: string = "https://back.galera.fm/api/Contact";
export const API_URL_PRIORITY: string = "https://back.galera.fm/api/Priority";
export const API_URL_VALUTA: string = "https://back.galera.fm/api/Valuta";
export const API_URL_TASK: string = "https://back.galera.fm/api/Task";
export const API_URL_SELLING: string = "https://back.galera.fm/api/Selling";
export const API_URL_COMMENT: string = "https://back.galera.fm/api/Comment";
export const API_URL_FINANCE: string = "https://back.galera.fm/api/Finance";
export const API_URL_BASKET: string = "https://back.galera.fm/api/Basket";
export const AUTH: string = "auth";
